/**
 * Phase 2 SEO landing pages — content only, no logic.
 * Rendered by `pages/LandingPage.jsx`.
 */

const CATEGORY_LINKS = [
  { path: '/lehengas', title: 'Designer Lehengas', body: 'Bridal red velvet, cocktail sequin & sangeet lehengas.' },
  { path: '/sarees', title: 'Indian Sarees', body: 'Banarasi silk, Kanjivaram & designer pre-drape sarees.' },
  { path: '/bridal-wear', title: 'Bridal Wear', body: 'Heirloom wedding lehengas, phera sarees & receptions.' },
  { path: '/kurti-sets', title: 'Kurti & Sharara Sets', body: 'Anarkalis, palazzo suits, sharara & cord sets.' },
  { path: '/shararas', title: 'Sharara Suits', body: 'Flowy sharara & gharara sets for festivals & weddings.' },
  { path: '/gowns', title: 'Indian Party Wear Gowns', body: 'Indo-western gowns for cocktails & receptions.' },
  { path: '/men', title: "Men's Kurta Pajama", body: 'Kurtas, sherwanis, Nehru jackets and Indo-western sets.' },
  { path: '/kids', title: 'Kids Indian Clothing', body: 'Girls lehengas, boys kurta sets, family-matching outfits.' },
  { path: '/plus-size', title: 'Plus Size Indian Clothing', body: 'XL to XXXL with custom sizing available on request.' },
];

const FAQ_SHIP = {
  q: 'Do you ship Indian clothes across the USA?',
  a: 'Yes — we ship across the United States. Local Triangle customers can pick up from our Morrisville boutique. For customers elsewhere, WhatsApp us on +1 984-377-9835 and we\'ll walk you through sizing and shipping.',
};
const FAQ_SIZE = {
  q: 'How do I choose the right size for online orders?',
  a: 'Most pieces are available XS – XXL with custom sizing on request. Share your bust / waist / hip measurements on WhatsApp — we\'ll recommend the best fit and tailor before shipping if needed.',
};
const FAQ_RENT = {
  q: 'Do you rent Indian outfits?',
  a: 'We are a retail boutique — every outfit is curated for purchase. If you have a specific event, WhatsApp us and we\'ll suggest pieces that suit the occasion and your budget.',
};
const FAQ_VISIT = {
  q: 'Can I visit your boutique in Morrisville, NC?',
  a: 'Absolutely — 158 Liberty Rose Dr, Morrisville, NC 27560. Open daily 4:30 PM – 8:30 PM. Call or WhatsApp 984-377-9835 to book a private appointment.',
};
const FAQ_WEDDING = {
  q: 'What outfits are best for Indian weddings?',
  a: 'For the bride, hand-embroidered lehengas or heavy Banarasi sarees. Guests love cocktail lehengas, sequin sarees or Anarkali suits. Sangeet & mehendi lean lighter — organza sarees, sharara sets or gowns work beautifully.',
};

export const LANDING_PAGES = {
  'indian-clothing-usa': {
    slug: 'indian-clothing-usa',
    title: 'Indian Clothing USA · Ships Nationwide | Trendy Closet',
    description: 'Shop Indian clothing online across the USA — lehengas, sarees, sharara suits, kurti sets, gowns, bridal wear and more. Boutique in Morrisville, NC ships nationwide.',
    h1: 'Indian Clothing in the USA',
    intro: 'Trendy Closet is a family-owned Indian clothing boutique in Morrisville, NC — and we ship across the entire United States. From bridal lehengas to everyday kurti sets, sharara suits, gowns and men\'s and kids\' ethnic wear, our curated collection brings Indian craftsmanship to your doorstep.',
    keyword: 'Indian Clothing USA',
    categories: CATEGORY_LINKS,
    faqs: [FAQ_SHIP, FAQ_SIZE, FAQ_WEDDING, FAQ_VISIT, FAQ_RENT],
  },
  'indian-clothing-morrisville-nc': {
    slug: 'indian-clothing-morrisville-nc',
    title: 'Indian Clothing Morrisville NC · Boutique | Trendy Closet',
    description: 'Indian clothing boutique in Morrisville, NC — lehengas, sarees, sharara suits, kurti sets, gowns & bridal wear. Family-owned, owner-styled. Book an appointment.',
    h1: 'Indian Clothing in Morrisville, NC',
    intro: 'Trendy Closet is Morrisville\'s owner-styled Indian clothing boutique — at 158 Liberty Rose Dr, minutes from Cary, Raleigh, Durham and Apex. Come see bridal lehengas, sarees, sharara sets, gowns and everyday festive wear in person, or book a private appointment.',
    keyword: 'Indian Clothing Morrisville NC',
    city: 'Morrisville',
    categories: CATEGORY_LINKS,
    faqs: [FAQ_VISIT, FAQ_WEDDING, FAQ_SIZE, FAQ_SHIP, FAQ_RENT],
  },
  'indian-clothing-raleigh-nc': {
    slug: 'indian-clothing-raleigh-nc',
    title: 'Indian Clothing Raleigh NC · Boutique | Trendy Closet',
    description: 'Indian clothing boutique serving Raleigh, NC — lehengas, sarees, sharara suits, kurti sets, gowns & bridal wear. Visit our Morrisville showroom, minutes from Raleigh.',
    h1: 'Indian Clothing near Raleigh, NC',
    intro: 'Raleigh customers, Trendy Closet is right around the corner — our boutique is a short drive in Morrisville, and we\'re the Triangle\'s go-to for owner-styled Indian ethnic wear. From bridal lehengas to sharara sets, kurti sets and men\'s kurta-pajama, we\'ve got Raleigh\'s Indian community styled for every occasion.',
    keyword: 'Indian Clothing Raleigh NC',
    city: 'Raleigh',
    categories: CATEGORY_LINKS,
    faqs: [FAQ_VISIT, FAQ_WEDDING, FAQ_SIZE, FAQ_SHIP, FAQ_RENT],
  },
};

export default LANDING_PAGES;
